// -------------- State -------------- //
const defaultState = () => ({
  isPostProcessingRequestState: false,
  isPostProcessingResultsState: false,
})
const state = defaultState()


// -------------- Mutations -------------- //
const MUTATION_TYPES = {
  SET_IS_POST_PROCESSING_REQUEST_STATE: "SET_IS_POST_PROCESSING_REQUEST_STATE",
  SET_IS_POST_PROCESSING_RESULTS_STATE: "SET_IS_POST_PROCESSING_RESULTS_STATE",
  CLEAN_MAPVIEW: "CLEAN_MAPVIEW",
}

const mutations = {
  [MUTATION_TYPES.SET_IS_POST_PROCESSING_REQUEST_STATE](state, isPostProcessingRequestState) {
    state.isPostProcessingRequestState = isPostProcessingRequestState
  },
  [MUTATION_TYPES.SET_IS_POST_PROCESSING_RESULTS_STATE](state, isPostProcessingResultsState) {
    state.isPostProcessingResultsState = isPostProcessingResultsState
  },
  [MUTATION_TYPES.CLEAN_MAPVIEW](state) {
    Object.assign(state, defaultState())
  },
}


// -------------- Getters -------------- //
export const GET_IS_POST_PROCESSING_REQUEST_STATE = "GET_IS_POST_PROCESSING_REQUEST_STATE"
export const GET_IS_POST_PROCESSING_RESULTS_STATE = "GET_IS_POST_PROCESSING_RESULTS_STATE"

const getters = {
  [GET_IS_POST_PROCESSING_REQUEST_STATE](state) {
    return state.isPostProcessingRequestState
  },
  [GET_IS_POST_PROCESSING_RESULTS_STATE](state) {
    return state.isPostProcessingResultsState
  },
}


// -------------- Actions -------------- //
export const SET_IS_POST_PROCESSING_REQUEST_STATE = "SET_IS_POST_PROCESSING_REQUEST_STATE"
export const SET_IS_POST_PROCESSING_RESULTS_STATE = "SET_IS_POST_PROCESSING_RESULTS_STATE"
export const CLEAN_MAPVIEW = "CLEAN_MAPVIEW"

const actions = {
  [SET_IS_POST_PROCESSING_REQUEST_STATE]({commit}, isPostProcessingRequestState) {
    commit(MUTATION_TYPES.SET_IS_POST_PROCESSING_REQUEST_STATE, isPostProcessingRequestState)
  },
  [SET_IS_POST_PROCESSING_RESULTS_STATE]({commit}, isPostProcessingResultsState) {
    commit(MUTATION_TYPES.SET_IS_POST_PROCESSING_RESULTS_STATE, isPostProcessingResultsState)
  },
  [CLEAN_MAPVIEW]({commit}) {
    commit(MUTATION_TYPES.CLEAN_MAPVIEW)
  },
}

export default {
  mutations,
  getters,
  actions,
  state,
}
